document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('.koji-faq-item');

  faqItems.forEach(item => {
    const questionBtn = item.querySelector('.koji-faq-question');

    questionBtn.addEventListener('click', () => {
      const isActive = item.classList.contains('is-active');

      // (Opzionale ma Premium) Chiudi tutti gli altri aperti
      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.classList.remove('is-active');
          otherItem.querySelector('.koji-faq-question').setAttribute('aria-expanded', 'false');
        }
      });

      // Togla lo stato di quello cliccato
      if (isActive) {
        item.classList.remove('is-active');
        questionBtn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-active');
        questionBtn.setAttribute('aria-expanded', 'true');
      }
    });
  });
});